import { DOCUMENT, inject, Injectable } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { filter, take } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class SplashScreenService {
  private document = inject<any>(DOCUMENT);
  private router = inject(Router);
  splashScreenEl: HTMLElement | null = null;
  player: Animation | undefined;

  constructor() {
    this._init();
  }

  private _init(): void {
    this.splashScreenEl = this.document.body.querySelector('#app-splash-screen');

    if (this.splashScreenEl) {
      this.router.events
        .pipe(
          filter((event): event is NavigationEnd => event instanceof NavigationEnd),
          take(1),
        )
        .subscribe(() => {
          this.hide();
        });
    }
  }

  show(): void {
    if (!this.splashScreenEl) {
      return;
    }

    Object.assign(this.splashScreenEl.style, {
      opacity: '0',
      zIndex: '99999',
    });

    this.player = this.splashScreenEl.animate([{ opacity: '0' }, { opacity: '1' }], {
      duration: 400,
      easing: 'ease',
      fill: 'forwards',
    });
  }

  hide(): void {
    if (!this.splashScreenEl) {
      return;
    }

    this.player = this.splashScreenEl.animate([{ opacity: '1' }, { opacity: '0' }], {
      duration: 400,
      easing: 'ease',
      fill: 'forwards',
    });

    this.player.onfinish = () => {
      if (this.splashScreenEl) {
        this.splashScreenEl.style.zIndex = '-10';
      }
    };
    clearInterval(Number(localStorage.getItem('splash-screen')));
  }
}
